import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbItem } from '../../models/breadcrumb.interface';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [MatIconModule, NgFor, NgIf, RouterModule, TranslateModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];
  @Output() onItemClicked: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) {}

  onClick(item: BreadcrumbItem) {
    if (item.url) {
      this.router.navigate([item.url]);
    } else {
      this.onItemClicked.emit(item);
    }
  }
}
